import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "contact",
  "data-model-id": "3:4242"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavSubsection = _resolveComponent("NavSubsection")!
  const _component_HeroSubsection = _resolveComponent("HeroSubsection")!
  const _component_ContactFormSubsection = _resolveComponent("ContactFormSubsection")!
  const _component_InfoCardsSubsection = _resolveComponent("InfoCardsSubsection")!
  const _component_MapSubsection = _resolveComponent("MapSubsection")!
  const _component_FooterSubsection = _resolveComponent("FooterSubsection")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavSubsection),
    _createVNode(_component_HeroSubsection),
    _createVNode(_component_ContactFormSubsection),
    _createVNode(_component_InfoCardsSubsection),
    _createVNode(_component_MapSubsection),
    _createVNode(_component_FooterSubsection)
  ]))
}